// Componente Card reutilizable para la aplicación Amarsi Control Panel
// Proporciona un contenedor estilizado con diferentes variantes y sombras

import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Componente Card
 * 
 * Contenedor reutilizable con estilos consistentes
 * Soporta diferentes variantes y niveles de sombra
 */
const Card = ({ 
  children, 
  className = '', 
  variant = 'default',
  shadow = 'medium',
  padding = 'normal',
  ...props 
}) => {
  // Define las clases base según la variante
  const variantClasses = {
    default: 'bg-white dark:bg-neutral-800 rounded-2xl border border-neutral-200 dark:border-neutral-700',
    elevated: 'bg-white dark:bg-neutral-800 rounded-2xl shadow-lg border-0 dark:shadow-xl',
    outlined: 'bg-white dark:bg-neutral-800 rounded-2xl border-2 border-neutral-300 dark:border-neutral-600',
    ghost: 'bg-neutral-50 dark:bg-neutral-700 rounded-2xl border-0',
  };

  // Define las clases de sombra
  const shadowClasses = {
    none: '',
    small: 'shadow-sm dark:shadow-neutral-900/20',
    medium: 'shadow-md dark:shadow-neutral-900/30',
    large: 'shadow-lg dark:shadow-neutral-900/40',
    xl: 'shadow-xl dark:shadow-neutral-900/50',
  };

  // Define las clases de padding
  const paddingClasses = {
    none: '',
    small: 'p-3',
    normal: 'p-6',
    large: 'p-8',
    xlarge: 'p-10',
  };

  // Combina todas las clases
  const cardClasses = cn(
    variantClasses[variant],
    shadowClasses[shadow],
    paddingClasses[padding],
    className
  );

  return (
    <div 
      className={cardClasses}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
